module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('label', {
    class: _vm.classesLabel
  }, [_vm._v(_vm._s(_vm.label) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group__input"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.filteredItems), function(item) {
    return [_c('div', [_c('v-tooltip', {
      attrs: {
        "bottom": "",
        "open-delay": "500",
        "max-width": "20em"
      }
    }, [_c('div', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('v-chip', {
      key: _vm.getKey(item),
      attrs: {
        "tabindex": _vm.tabindex,
        "small": "",
        "text-color": _vm.errorItemMessage(item) ? 'error' : 'black',
        "close": !_vm.disabled
      },
      on: {
        "click": function($event) {
          return _vm.addItem(item)
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.addItem(item)
        },
        "input": function($event) {
          return _vm.removeItem(item)
        },
        "focus": function($event) {
          return _vm.onFocus()
        },
        "blur": function($event) {
          return _vm.onBlur()
        }
      }
    }, [(_vm.getImg(item)) ? _c('v-avatar', [_c('img', {
      attrs: {
        "src": _vm.getImg(item),
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.getText(item)) ? _c('span', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n        " + _vm._s(_vm.getText(item)) + "\n      ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('span', {
      staticStyle: {
        "overflow-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(_vm.getHint(item)))]), _vm._v(" "), _c('div', {
      staticClass: "error",
      attrs: {
        "light": ""
      }
    }, [_vm._v(_vm._s(_vm.errorItemMessage(item)))])])], 1)]
  }), _vm._v(" "), _c('v-chip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emptyAlways || _vm.isEmpty),
      expression: "emptyAlways || isEmpty"
    }],
    attrs: {
      "small": "",
      "tabindex": _vm.tabindex,
      "text-color": "secondary",
      "disabled": !_vm.emptyEnabled && _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.addItem()
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addItem()
      },
      "focus": function($event) {
        return _vm.onFocus()
      },
      "blur": function($event) {
        return _vm.onBlur()
      }
    }
  }, [_c('span', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n        " + _vm._s(this.emptyChip) + "\n        ")])])], 2)], 1), _vm._v(" "), (_vm.hint) ? _c('div', {
    staticClass: "input-group__details"
  }, [_c('div', {
    staticClass: "input-group__messages input-group__hint v-messages theme--light v-messages__wrapper v-messages__message"
  }, [_vm._v(_vm._s(_vm.hint))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91c7c7e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ChipsField.vue
// module id = 817
// module chunks = 1